module.exports = __webpack_public_path__ + "static/media/bookings.58bc4b24.svg";